import entering from './animations/entering-animation'
import exiting from './animations/exiting-animation'
import basic from './animations/basic-animation'

export const animations = [
  entering,
  exiting,
  basic
]
